import { z } from 'zod'

/** Represents the enum public.correction_method_type_ */
enum CorrectionMethodType {
  additive = 'additive',
  multiplicative = 'multiplicative',
}

export default CorrectionMethodType

/** Zod schema for correction_method_type_ */
export const correctionMethodType = z.enum(['additive', 'multiplicative'])
